var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"glow-image",style:({
    width: _vm.width + 'px',
    borderRadius: _vm.rounding,
})},[_c('div',{staticClass:"album-art album-background",style:({
                backgroundImage: ("url(" + _vm.src + ")"),
                opacity: _vm.$vuetify.theme.dark ? 0.4 : 0.7,
                minWidth: _vm.width + 'px',
                height: _vm.height + 'px',
                right: (-_vm.width / 2) + 'px',
                borderRadius: _vm.rounding,
                top: (_vm.height / 16) + 'px',
                filter: ("blur(" + (_vm.width / 16) + "px)"),
             })}),_c('div',{staticClass:"album-art album-normal",style:({
        backgroundImage: ("url(" + _vm.src + ")"),
        minWidth: _vm.width + 'px',
        height: _vm.height + 'px',
        left: (-_vm.width / 2) + 'px',
        borderRadius: _vm.rounding,
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }